import Handlebars from "handlebars/dist/handlebars.js";

var faq = (function() {
"use strict";

	var faq = $('.faq');

	if (faq.length > 0) {

		var win 		= $(window),
			main 		= $('#main'),
			qWrapper 	= $('.questions-wrapper'),
			leftList 	= $('.left .questions'),
			rightList	= $('.right .questions'),
			source   	= $("#faq-item-template").html(),
			template 	= Handlebars.compile(source),
			cl 			= new CanvasLoader('loader');

		cl.setDensity(15);
		cl.setRange(1);
		cl.setSpeed(1);
		cl.setFPS(22);
		cl.setColor('#000000');

		win.on('load', getQuestions);

		main.on('change', '.faq-filter select', function(e) {
			var $this 		= $(this),
				selected 	= $this.find('option:selected').val();

			$this.attr('disabled', 'disabled').trigger('liszt:updated');

			getQuestions(e, selected);
		});

		main.on('click', '.faq .questions li', function() {
			$(this).find('.answer').toggle();
		});
	}

	function getQuestions(e, selected) {

	    if (typeof selected === 'undefined') {
	        selected = main.find('option:selected', 'faq-filter select').val();
	    }

        var data = {
            "pageId": SETTINGS.pageid,
		    "categoryId": selected
		};

		qWrapper.hide();
		cl.show();
		leftList.empty();
		rightList.empty();

		// AJAX request
		var ajaxRequest = $.ajax({
		    url: SETTINGS.services.site.methods.getQuestions,
			data: JSON.stringify(data)
		});

		ajaxRequest.done(doneHandler);
		ajaxRequest.fail(failHandler);

		// AJAX responses
		function doneHandler(response) {

		    if (response.Success && response.Data.Questions.length > 0) {
		        // Divide response into two parts
		        var part1 = {},
                    part2 = {};

		        part1['Data'] = [];
		        part2['Data'] = [];

		        for (var i = 0; i < response.Data.Questions.length; i++) {
		            if (i % 2 === 0) {
		                part1.Data.push(response.Data.Questions[i]);
		            } else {
		                part2.Data.push(response.Data.Questions[i]);
		            }
		        }

		        var leftQuestions = template(part1),
                    rightQuestions = template(part2);

		        leftList.append(leftQuestions);
		        rightList.append(rightQuestions);
		        
		    } else if(!response.Success) {
		        
		    }
		    cl.hide();
		    qWrapper.fadeIn(100);
		    faq.find('.chosen').removeAttr('disabled').trigger('liszt:updated');
		    //faq.css({ minHeight: faq.height() });
		}

		function failHandler(err) {			
		}
	}
})();